module.exports = __webpack_public_path__ + "static/media/b-3.12c6519b.jpg";